module.exports = __webpack_public_path__ + "img/s1_t1_14.c3bc9c28.jpeg";